import { render, staticRenderFns } from "./hotel-score-dimension-list.vue?vue&type=template&id=667dc4cb"
import script from "./hotel-score-dimension-list.vue?vue&type=script&lang=ts"
export * from "./hotel-score-dimension-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports